import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ServiceReqResModel } from "../assets/model/serviceReqRes.model";
import { CustomerSearchReqResModel } from "../assets/model/customerSearchReqResmodel.model";

@Injectable()
export class CommonService extends BaseService {
  private serviceModel: ServiceReqResModel = new ServiceReqResModel();
  private orderId: number;
  public batch: any;
  public fundsBatch: any;
  public greenfieldBatchId: any;
  private gameIdsArray: any = [];
  private accessToken: any;
  public parish: any;
  public clientIp: any = "";
  public static fintechScreenName: string = "";
  public static scrollPageX: number = 0;
  public static scrollPageY: number = 0;
  public static scrollPageXAnalytics: number = 0;
  public static scrollPageYAnalytics: number = 0;
  private clientType = "WEB";
  private deviceId: any = "";
  private accessRoleData: any;
  public static apiErrorStatus: boolean = false;
  public static latitude: any = "";
  public static longitude: any = "";
  private accessMedium: any = "";
  public retailerData: any;
  public consumerData: Map<String, any> = new Map<String, any>();
  private customerSearchReqResModel: any;
  serviceProvider: any;
  public globalCartData: any = { bettingDetails: [] };
  public getConsumerData(key) {
    return this.consumerData.get(key);
  }

  public constructor(_http: HttpClient) {
    super(_http);
  }

  public setConsumerData(key, value) {
    this.consumerData.set(key, value);
  }

  public setAccessMedium(code) {
    this.accessMedium = code;
    localStorage.setItem("ACCESSMEDIUM", JSON.stringify(code));
  }

  setClientIP(ipAddress) {
    this.clientIp = ipAddress;
  }

  getClientIP() {
    return this.clientIp;
  }

  setGameIdsArray(games) {
    this.gameIdsArray = games;
  }
  getGameIdsArray() {
    return this.gameIdsArray;
  }
  getCurrentGameId(gamename: String) {
    for (let i = 0; i < this.gameIdsArray.length; i++) {
      if (this.gameIdsArray[i]["gameName"] === gamename) {
        let id = this.gameIdsArray[i]["gameId"];
        return parseInt(id);
      }
    }
  }
  getCustomerSearchReqResModel() {
    return this.customerSearchReqResModel;
  }
  setCustomerSearchReqResModel(model) {
    this.customerSearchReqResModel = model;
  }
  setAccessToken(token) {
    this.accessToken = token;
  }
  setClientType(clientType) {
    this.clientType = clientType;
  }
  getClientType() {
    return this.clientType;
  }
  setDeviceId(deviceId) {
    this.deviceId = deviceId;
  }
  getDeviceId() {
    return this.deviceId;
  }
  getAccessToken() {
    return this.accessToken;
  }
  getOrderId() {
    return this.orderId;
  }
  setOrderId(id) {
    this.orderId = id;
  }
  getGameId() {
    return this.gameId;
  }
  setGameId(id) {
    this.gameId = id;
  }
  getServiceModel() {
    return this.serviceModel;
  }

  setBatchId(id) {
    this.batch = id;
  }
  getBatchId() {
    return this.batch;
  }

  setFundsBatchId(id) {
    this.fundsBatch = id;
  }
  getFundsBatchId() {
    return this.fundsBatch;
  }

  setGreenfieldFundsBatchId(id) {
    this.greenfieldBatchId = id;
  }
  getGreenfieldFundsBatchId() {
    return this.greenfieldBatchId;
  }

  public setRetailerData(res) {
    this.retailerData = res;
  }

  public getRetailerData() {
    return this.retailerData;
  }

  setServiceModel(serviceModel) {
    this.serviceModel = serviceModel;
  }

  setServiceProvider(provider) {
    this.serviceProvider = provider;
  }
  getServiceProvider() {
    return this.serviceProvider;
  }
  public fetchInvoicePdf(url): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({});
    return super.makeGetRequestForFiles(url, headers);
  }
  public verestroEod(body, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-verestro-history`;
    body.isAll = isAll;
    return this.regularPostRequest(url, body, headers);
  }
  setRunPeriod(fromDate, tillDate) {
    let dateFrom = "";
    let dateTo = "";
    if (
      (tillDate == null || tillDate == "") &&
      (fromDate == null || fromDate == "")
    ) {
      dateFrom = new Date().toLocaleDateString("en-GB");
      dateTo = new Date().toLocaleDateString("en-GB");
    } else {
      dateFrom = new Date(fromDate).toLocaleDateString("en-GB");
      dateTo = new Date(tillDate).toLocaleDateString("en-GB");
    }
    let RunPeriod = dateFrom + "-" + dateTo;
    return RunPeriod;
  }
  public showAccessDenied = false;

  public getNewRegistrationReport(body, isAll, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-newregistration-report?page=${page}&limit=50&isAll=${isAll}&merchantId="JM"`;
    if (body.dateFrom) {
      url += `&startDate=${body.dateFrom}`;
    } if (body.dateTo) {
      url += `&endDate=${body.dateTo}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public manageCards(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/manage-user-cards?page=${page}&limit=10`;
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    if (body.last_four_digits) {
      url += `&last_four_digits=${body.last_four_digits}`;
    }
    return this.regularPostRequest(url, '', headers);
  }
  public getChargeback(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-chargeback-data?page=${page}`;
    if (body.createdAtFrom) {
      url += `&createdAtFrom=${body.createdAtFrom}`;
    }
    if (body.createdAtTo) {
      url += `&createdAtTo=${body.createdAtTo}`;
    }
    if (body.dateTransactionAttemptedFrom) {
      url += `&dateTransactionAttemptedFrom=${body.dateTransactionAttemptedFrom}`;
    }
    if (body.dateTransactionAttemptedTo) {
      url += `&dateTransactionAttemptedTo=${body.dateTransactionAttemptedTo}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    if (body.authCode) {
      url += `&authCode=${body.authCode}`;
    }
    if (body.cardNo) {
      url += `&cardNo=${body.cardNo}`;
    }
    if (body.mobileNo) {
      url += `&mobileNo=${body.mobileNo}`;
    }
    if (body.name) {
      url += `&name=${body.name}`;
    }
    if (body.limit) {
      url += `&limit=${body.limit}`
    }
    return this.regularGetRequest(url, headers);
  }

  public addChargeback(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/add-chargeback-data`;
    return this.regularPostRequest(url, body, headers);
  }
  public updateChargeback(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/edit-chargeback-data`;
    return this.regularPostRequest(url, body, headers);
  }
  public deleteChargeback(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-chargeback-data`;
    return this.regularPostRequest(url, body, headers);
  }
  public getSagicorInvoice(transactionId, parentId) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-consumer-invoice`;
    if (transactionId) {
      url += `?transactionId=` + transactionId;
    }
    if (parentId) {
      url += `?parentId=` + parentId;
    }
    return this.regularGetRequest(url, headers);
  }

  public getLascoInvoice(transactionId) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/lasco-consumer-invoice`;
    if (transactionId) {
      url += `?transactionId=` + transactionId;
    }
    return this.regularGetRequest(url, headers);
  }

  public getPreviousAmount(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-location-transaction-data?page=${page}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getSLPPreviousAmount(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-location-transaction-topup-data-ui?page=${page}`;
    return this.regularPostRequest(url, body, headers);
  }

  public submitLocationTransactionData(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/submit-location-transaction-data`;
    return this.regularPostRequest(url, body, headers);
  }

  public submitSLPLocationTransactionData(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/submit-location-transaction-topup-data-ui`;
    return this.regularPostRequest(url, body, headers);
  }

  public retailersSearch(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/bdo-search?page=${page}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public getVouchers(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-voucher-requests?&page=${page}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.transactionDateFrom) {
      url += `&transactionDateFrom=${body.transactionDateFrom}`;
    }
    if (body.transactionDateTo) {
      url += `&transactionDateTo=${body.transactionDateTo}`;
    }
    if (body.voucherType) {
      url += `&voucherType=${body.voucherType}`;
    }
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.transactionId) {
      url += `&transactionId=${body.transactionId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getRiaFundsHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-ria-manage-wallet-transactions?&page=${page}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public riaMarkFailedTxn(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/mark-ria-order-failed`;
    return this.regularPostRequest(url, body, headers);
  }

  public updateConsumerProfile(body: any): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`
    });
    const url = 'api/update-consumer-profile';
    return this.regularPostRequest(url, body, headers);
  }
  public getConsumerProfile(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-audit-logs?page=${page}&limit=50&isAll=${isAll}`;
    if (body.date_from) {
      url += `&date_from=${body.date_from}`;
    }
    if (body.date_to) {
      url += `&date_to=${body.date_to}`;
    }
    if (body.event) {
      url += `&event=${body.event}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getDepositHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/deposit-history?&page=${page}&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getInfluencerDataReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-influencer-data-report?&page=${page}&isAll=${isAll}&limit=20`;
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.name) {
      url += `&name=${body.name}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.amountCredited) {
      url += `&amountCredited=${body.amountCredited}`;
    }
    if (body.promoCode) {
      url += `&promoCode=${body.promoCode}`;
    }
    if (body.accountStatus) {
      url += `&accountStatus=${body.accountStatus}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getChargeup(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-chargeup-files?&page=${page}&isAll=${isAll}&limit=20`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.providerType) {
      url += `&providerType=${body.providerType}`
    }
    return this.regularGetRequest(url, headers);
  }

  public esimImportFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/upload-recharge-pins`;
    return this.regularPostRequest(url, body, headers);
  }

  public activatePin(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/activate-pinsV2`;
    return this.regularPostRequest(url, body, headers);
  }
  public deActivatePin(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/deactivate-pins`;
    return this.regularPostRequest(url, body, headers);
  }

  public cancelPin(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-pins`;
    return this.regularPostRequest(url, body, headers);
  }

  public viewVoucher(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/view-voucher-request?id=${id}`;
    return this.regularGetRequest(url, headers);
  }

  public viewLogs(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-voucher-log-history?id=${id}`;
    return this.regularGetRequest(url, headers);
  }

  public requestVoucher(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/create-voucher-request`;
    return this.regularPostRequest(url, body, headers);
  }
  public getCouponSearch(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-coupon-data?&page=${page}&limit=50&isAll=${isAll}`;
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.couponCode) {
      url += `&couponCode=${body.couponCode}`;
    }
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`
    }
    return this.regularGetRequest(url, headers);
  }

  public addCoupon(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/create-coupon`;
    return this.regularPostRequest(url, body, headers);
  }

  public deleteCoupon(code): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/delete-coupon?&code=${code}`;
    return this.regularGetRequest(url, headers);
  }

  public updateCouponStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/disable-enable-coupon`;
    return this.regularPostRequest(url, body, headers);
  }

  public approveVoucher(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/approve-voucher-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public approveDeposit(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/approve-payment`;
    return this.regularPostRequest(url, body, headers);
  }
  //approve-manage-retailer-deposit
  public approveRetailerDeposit(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/approve-clear-deposit`;
    return this.regularPostRequest(url, body, headers);
  }

  public rejectVoucher(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/reject-voucher-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public updateRiaPaymentStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/update-ria-payment-status`;
    return this.regularPostRequest(url, body, headers);
  }

  public rejectDeposit(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/reject-payment`;
    return this.regularPostRequest(url, body, headers);
  }

  //reject retailer deposit  history

  public rejectRetailerDeposit(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/reject-deposit-verify-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public cancelVoucher(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/cancel-voucher-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public sendNotification(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/send-push-notification-to-all`;
    return this.regularPostRequest(url, body, headers);
  }

  public getNotificationHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-push-notification-histories?&page=${page}&limit=10&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getRetailerById(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-bdo-retailer-by-id`;
    return this.regularPostRequest(url, body, headers);
  }

  public updateStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/update-bdo-retailer-status-tracker`;
    return this.regularPostRequest(url, body, headers);
  }

  public pinsSummary(merchant): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/pins-summary?merchantId=${merchant}`;
    return this.regularGetRequest(url, headers);
  }

  public eodTopupSummary(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/topup-eod?page=${page}`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public jpsPrepaidEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/jps-prepaid-eod?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public topupHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/topup-transaction-history?&page=${page}&limit=50&isAll=${isAll}`;
    // if(isAll) {
    //   url += `&isAll=true`;
    // }
    return this.regularPostRequest(url, body, headers);
  }

  public importFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/process-mass-payment`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmImportFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-mass-payment`;
    return this.regularPostRequest(url, body, headers);
  }

  public setParishBDO(res) {
    this.parish = res;
  }

  public getParishBDO() {
    return this.parish;
  }
  public topupSummary(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/topup-summary?&page=${page}&limit=50&isAll=${isAll}`;
    // if(isAll) {
    //   url += `&isAll=true`;
    // }
    return this.regularPostRequest(url, body, headers);
  }
  public userReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-users-report?&page=${page}&limit=50&isAll=${isAll}`;
    // if(isAll) {
    //   url += `&isAll=true`;
    // }
    return this.regularPostRequest(url, body, headers);
  }

  public edufocalEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-edufocal-history?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public detailedReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/charge-up-detailed-report?page=${page}&limit=100&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public transactionHistoryReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-transaction-history?page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public weeklyReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/weekly-charge-up-eod?page=${page}&limit=100&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public readyCreditEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-ready-credit-history?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public blinkskyEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/blinksky-eod-report?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public chargeupEod(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/charge-up-eod?page=${page}&limit=50&version=1.1`;
    return this.regularPostRequest(url, body, headers);
  }

  public getChargeupCommissionReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/charge-up-commission-report?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getFxRates() {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-fx-rates`;
    return this.regularGetRequest(url, headers);
  }

  public saveFxRates(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/save-fx-rates`;
    return this.regularPostRequest(url, body, headers);
  }

  public getBankDetails(branchName): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-bank-details?bankKey=${branchName}`;
    return this.regularGetRequest(url, headers);
  }

  public exportWithdrawalRequests(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/update-transaction-status`;
    return this.regularPostRequest(url, body, headers);
  }
  public getAllTransactionHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/transaction-report?&page=${page}`;
    if (body.gamer) {
      url += `&gamer=${body.gamer}`;
    }
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getAllLascoTransactionReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/lasco-report?&page=${page}&limit=50`;
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getsvlWalletTransactionHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/svl-wallet-transaction-history?&page=${page}&limit=50`;
    if (body.gamer) {
      url += `&gamer=${body.gamer}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  //retailer deposit history

  public getBackofficeRetailerDepositHistory(
    body,
    page,
    isAll
  ): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-retailer-deposit-history?&page=${page}&limit=10`;
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.from_date) {
      url += `&from_date=${body.from_date}`;
    }
    if (body.to_date) {
      url += `&to_date=${body.to_date}`;
    }
    if (body.retailer_id) {
      url += `&retailer_id=${body.retailer_id}`;
    }
    if (body.deposit_method) {
      url += `&deposit_method=${body.deposit_method}`;
    }
    if (body.deposit_location) {
      url += `&deposit_location=${body.deposit_location}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getRetailerDepositHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-deposit-request-history?&page=${page}&limit=10`;
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.from_date) {
      url += `&from_date=${body.from_date}`;
    }
    if (body.to_date) {
      url += `&to_date=${body.to_date}`;
    }
    if (body.retailer_id) {
      url += `&retailer_id=${body.retailer_id}`;
    }
    if (body.business_name) {
      url += `&business_name=${body.business_name}`;
    }
    if (body.deposit_method) {
      url += `&deposit_method=${body.deposit_method}`;
    }
    if (body.deposit_location) {
      url += `&deposit_location=${body.deposit_location}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getDailyStatistics(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/daily-summary-report`;
    return this.regularPostRequest(url, body, headers);
  }
  public getConsumerActivity(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/consumer-activity?&page=${page}`;
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getFinancialActivity(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'Platform-Type': 'JM'
    });
    let url = `api/financial-report?`;
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getTransactionSummary(id) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/user-consolidate-report?`;
    if (id) {
      url += `&consumerId=${id}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getInviteHistory(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/invite-history?page=${page}&limit=50`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getIncentiveeHistory(body, page) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/consumer-incentive-history?page=${page}&limit=50`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.invitedBy) {
      url += `&invitedBy=${body.invitedBy}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getAllBetHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/bet-history-report?&page=${page}`;
    if (body.gamer) {
      url += `&gamer=${body.gamer}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.game) {
      url += `&game=${body.game}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public getConsumerTransactionHistory(
    body,
    creationFromDate,
    creationToDate,
    page
  ): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-transaction-history?&page=${page}`;
    if (body.consumerId) {
      url += `consumerId=${body.consumerId}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.trnNumber) {
      url += `&trnNumber=${body.trnNumber}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.bankName) {
      url += `&bankName=${body.bankName}`;
    }
    if (body.branchName) {
      url += `&branchName=${body.branchName}`;
    }
    if (body.accountType) {
      url += `&accountType=${body.accountType}`;
    }
    if (creationFromDate) {
      url += `&creationFromDate=${creationFromDate}`;
    }
    if (creationToDate) {
      url += `&creationToDate=${creationToDate}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public exportAllWithdrawToBankTransactions(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-transactions?&page=${page}`;
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.trnNumber) {
      url += `&trnNumber=${body.trnNumber}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.bankName) {
      url += `&bankName=${body.bankName}`;
    }
    if (body.branchName) {
      url += `&branchName=${body.branchName}`;
    }
    if (body.accountType) {
      url += `&accountType=${body.accountType}`;
    }
    if (body.creationFromDate) {
      url += `&creationFromDate=${body.creationFromDate}`;
    }
    if (body.creationToDate) {
      url += `&creationToDate=${body.creationToDate}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public exportAllWithdrawMmgTransactions(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-transaction-history-gy?&isAll=true`;
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public getLuckyFivePrize(drawId: number, merchantId: string) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-lucky-five-prize-tiers?drawId=${drawId}&merchantId=${merchantId}`;
    return this.regularGetRequest(url, headers);
  }

  //direct-funds-transfer-apis

  public getDirectFundsTransferHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/direct-funds-history?&page=${page}&limit=100&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //get-greenfield-funds-transfer
  public getGreenfieldFundsTransferHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/greenfield-commission-transfer-history?&page=${page}&limit=100&isAll=${isAll}`;
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public importGreenfieldFundsFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/process-greenfield-commission`;
    return this.regularPostRequest(url, body, headers);
  }

  public getGreenfieldUnidentifiedFundsData(
    batchId,
    transactionType,
    page,
    isAll
  ) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-all-greenfield-retailers-by-batchId?&batchId=${batchId}&transactionType=${transactionType}&page=${page}&limit=100&isAll=${isAll}`;
    return this.regularGetRequest(url, headers);
  }

  public confirmGreenfieldImportFundsFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-greenfield-commission`;
    return this.regularPostRequest(url, body, headers);
  }

  public removeTransaction(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-unidentified-direct-funds`;
    return this.regularPostRequest(url, body, headers);
  }

  public reverseTransaction(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/reverse-identified-direct-funds`;
    return this.regularPostRequest(url, body, headers);
  }

  //end//
  public importFundsFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/process-direct-funds`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmImportFundsFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-direct-funds`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmUnidentifiedmodal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-unidentified-deposit-batch`;
    return this.regularPostRequest(url, body, headers);
  }

  public importFundsFileunidentified(body) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/process-unidentified-transactions`;
    return this.regularPostRequest(url, body, headers);
  }

  public getUnidentifiedFundsData(batchId, transactionType, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-all-direct-funds-by-batchId?&batchId=${batchId}&transactionType=${transactionType}&page=${page}&limit=100&isAll=${isAll}`;
    return this.regularGetRequest(url, headers);
  }

  //--END of DFT APIS--//

  public getCsrEod(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/csr-eod`;
    return this.regularPostRequest(url, body, headers);
  }

  public getCSREod(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/csr-eod-bglc`;
    return this.regularPostRequest(url, body, headers);
  }

  public placePickFourBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-pick4-jm`;
    return this.regularPostRequest(url, body, headers);
  }
  public confirmPick4BetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-pick4-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public verifyPhoneNumber(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/send-invite`;
    return super.makePostRequest(url, body, headers).pipe(
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }

  public verifyOtp(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/send-invite`;

    return super.makePostRequest(url, body, headers).pipe(
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }

  public placePickThreeBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-pick3-jm`;
    return this.regularPostRequest(url, body, headers);
  }
  public confirmPick3BetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-pick3-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placePickTwoBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-pick2-jm`;
    return this.regularPostRequest(url, body, headers);
  }
  public confirmPick2BetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-pick2-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeLottoBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-lotto-jm`;
    return this.regularPostRequest(url, body, headers);
  }
  public confirmLottoBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-lotto-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeSuperLottoBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-superlotto-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeDollazBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-dollaz-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmSuperLottoBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-superlotto-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmDollazBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-dollaz-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeTopDrawBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-topdraw-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public confirmTopDrawBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-topdraw-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeLuckyFiveBets(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/bet-luckyfive-jm`;
    return this.regularPostRequest(url, body, headers);
  }
  public confirmLuckyFiveBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = `api/confirm-luckyfive-jm`;
    return this.regularPostRequest(url, body, headers);
  }

  public getGameRule(gameName): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/game-rule?nameName=${gameName}`;
    return this.regularGetRequest(url, headers);
  }
  public getKioskGameRule(gameName): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      // Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/kiosk/game-rule?nameName=${gameName}`;
    return this.regularGetRequest(url, headers);
  }

  public consumerBetHistory(
    dateFrom,
    dateTo,
    game,
    status,
    page,
    consumerId
  ): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-consumer-bet-history?dateFrom=${dateFrom}&dateTo=${dateTo}&game=${game}&page=${page}&consumerId=${consumerId}&status=${status}`;
    return this.regularGetRequest(url, headers);
  }

  public getPragmaticConsumerBetHistory(
    dateFrom,
    dateTo,
    gameId,
    status,
    limit,
    consumerId
  ): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-pragmatic-consumer-bet-history?consumerId=${consumerId}&limit=${limit}&gameId=${gameId}&betStatus=${status}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
    return this.regularGetRequest(url, headers);
  }

  public consumerAlternarBetHistory(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-altenar-consumer-bet-history?&page=${page}&limit=10`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.type) {
      url += `&betMode=${body.type}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.status) {
      url += `&betStatus=${body.status}`;
    }
    if (body.betReferenceNum) {
      url += `&betReferenceNum=${body.betReferenceNum}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public consumerMBetHistory(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-horse-racing-consumer-bet-history?&page=${page}&limit=10`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.type) {
      url += `&betType=${body.type}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.status) {
      url += `&betStatus=${body.status}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public async getAccessControl(screenName) {
    let body = { screenName: screenName };
    await this.getAccessRole(body)
      .toPromise()
      .then((res) => {
        this.accessRoleData = res;
        this.showAccessDenied = true;
      });
  }
  public isUserCanAddOrEdit() {
    if (this.accessRoleData) {
      return this.accessRoleData.add_or_edit == "1" ? true : false;
    }
  }
  public isUserCanDelete() {
    if (this.accessRoleData) {
      return this.accessRoleData.delete_view == "1" ? true : false;
    }
  }
  public isUserCanRead() {
    if (this.accessRoleData) {
      return this.accessRoleData.read_view == "1" ? true : false;
    }
  }
  public requestedData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/requested-data";
    return this.regularPostRequest(url, body, headers);
  }
  public allowTransactions(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/allow-transaction";
    return this.regularPostRequest(url, body, headers);
  }
  public activateAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/accept-account";
    return this.regularPostRequest(url, body, headers);
  }
  public consumerTransaction(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/financial-transactions?&page=${page}`;
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.source) {
      url += `&source=${body.source}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public uploadTicketReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-upload-tickets?&page=${page}&limit=20&isAll=${isAll}`;

    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.ticketUpload) {
      url += `&status=${body.ticketUpload}`;
    }
    if (body.parish) {
      url += `&parish=${body.parish}`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public transactionReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/cashin-cashout-transaction?&page=${page}&limit=20&isAll=${isAll}`;

    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.mobileNumber) {
      url += `&mobileNumber=${body.mobileNumber}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public accountLimits(userId): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/consumer-exhaust-limits?userId=${userId}`;

    return this.regularGetRequest(url, headers);
  }

  public getAllSvlTransactions(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-all-transaction-history?&page=${page}&limit=50&merchantType=JM`;
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.transactionType) {
      url += `&type=${body.transactionType}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public removeBankAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/consumer-bank";
    return this.regularDeleteRequest(url, body, headers);
  }
  public updateBankAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/consumer-bank";
    return this.regularPutRequest(url, body, headers);
  }
  public getBankAccounts(consumerId): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/consumer-bank?consumerId=" + consumerId;
    return this.regularGetRequest(url, headers);
  }
  public addBankAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/consumer-bank";
    return this.regularPostRequest(url, body, headers);
  }
  public activateConsumerAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/activate-account";
    return this.regularPostRequest(url, body, headers);
  }
  public deactivateConsumerAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/deactivate-account";
    return this.regularPostRequest(url, body, headers);
  }
  public blockFromCMS(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/blocked-from-cms";
    return this.regularPostRequest(url, body, headers);
  }
  public unlockConsumerAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/unlock-consumer";
    return this.regularPostRequest(url, body, headers);
  }
  public deactivateAccount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/reject-account";
    return this.regularPostRequest(url, body, headers);
  }
  public getApplications(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/application-search?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }
  public getcomplianceReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/compliance-report?page=${page}&limit=50`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getBlockedAccounts(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/compliance-report-bglc?page=${page}&limit=50`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getthresholdReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/threshold-report?page=${page}&limit=50`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  /** Duplicate Lite sign-up report. body: { fromDate, toDate, search } */
  public getLiteSignupAttemptsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/lite-signup-attempts-report?page=${page}&limit=50`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public getSummaryReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/super-sellaz-sales-tracker?page=${page}&limit=200`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public getSuperSellazSummaryReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/super-sellaz-summary-report?page=${page}&limit=200`;
    if (isAll) {
      url += `&isAll=true`;
    }
    return this.regularPostRequest(url, body, headers);
  }
  public addCredits(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/cashin`;
    return this.regularPostRequest(url, body, headers);
  }
  public addPromo(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/add-promo-by-admin`;
    return this.regularPostRequest(url, body, headers);
  }

  public removeCredits(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/cashout-by-admin`;
    return this.regularPostRequest(url, body, headers);
  }
  public updateDocStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/document-status";
    return this.regularPostRequest(url, body, headers);
  }
  public customerSummary(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/summary";
    return this.regularPostRequest(url, body, headers);
  }
  public getConsumerById(userID): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-consumer-by-id?userId=" + userID;
    return this.regularGetRequest(url, headers);
  }
  public customerSearch(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/customer-search?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //consent

  public getConsent(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/communication-consent-by-id?userId=${id}`;
    return this.regularGetRequest(url, headers);
  }

  public getConsentHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/communication-consents?page=${page}&limit=20&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getUserActivityHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/activity-report?&currentPage=${page}&limit=50&isAll=${isAll}`;
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.retailerName) {
      url += `&retailerFirstName=${body.retailerName}`;
    }
    if (body.retailerLogin) {
      url += `&retailerLogin=${body.retailerLogin}`;
    }
    if (body.consumerFirstName) {
      url += `&consumerFirstName=${body.consumerFirstName}`;
    }
    if (body.consumerLastName) {
      url += `&consumerLastName=${body.consumerLastName}`;
    }
    if (body.mobile) {
      url += `&consumerMobile=${body.mobile}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getGuyanaEodWalletHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/retailer-eod-wallet-history-gy-report`
    // ?&currentPage=${page}&limit=50&isAll=${isAll}`;
    // if (body.dateTo) {
    //   url += `&dateTo=${body.dateTo}`;
    // }
    // if (body.dateFrom) {
    //   url += `&dateFrom=${body.dateFrom}`;
    // }
    // if (body.type) {
    //   url += `&type=${body.type}`;
    // }
    // if(body.userId){
    //   url+=`&userId=${body.userId}`
    // }
    // return this.regularGetRequest(url, headers);
    
    return this.regularPostRequest(url, body, headers);
  }

  public getNewSignups(body,reportName): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-new-signups?reportName=${reportName}&page=${body.page}&limit=${body.limit}&isAll=${body.isAll}`;
    if (body.verificationStartDate) {
      url += `&verificationStartDate=${body.verificationStartDate}`;
    }
    if (body.verificationEndDate) {
      url += `&verificationEndDate=${body.verificationEndDate}`;
    }
    if (body.registrationStartDate) {
      url += `&registrationStartDate=${body.registrationStartDate}`;
    }
    if (body.registrationEndDate) {
      url += `&registrationEndDate=${body.registrationEndDate}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getDepositTopUpReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.accessToken}`,
        "Content-Type": "application/json",
    });
    let url = `api/get-customers-deposit-top-up-report?page=${body.page}&limit=${body.limit}&isAll=${body.isAll}`;
    
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) { 
      url += `&toDate=${body.toDate}`;
    }
    if (body.minAmount) {
      url += `&minAmount=${body.minAmount}`;
    }
    if (body.maxAmount) {
      url += `&maxAmount=${body.maxAmount}`;
    }

    return this.regularGetRequest(url, headers);
}
public getGyUserDetails(body, isAll, page) : Observable<any> {
  const headers: HttpHeaders = new HttpHeaders({
    Authorization: `Bearer ${this.accessToken}`,
    "Content-Type": "application/json",
  });
 
  let url = `api/get-gy-user?page=${page}&limit=50&isAll=${isAll}`;
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    } if (body.userId) {
      url += `&userId=${body.userId}`;
    }
    return this.regularGetRequest(url, headers);
}
public getGyMigratedUser(body):Observable<any>{
  const headers: HttpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.accessToken}`,
        "Content-Type": "application/json",
    });

    let url = `api/get-gy-migrated-users?limit=${body.limit}&page=${body.page}&isAll=${body.isAll}`;
    if(body.status){
      url+=`&status=${body.status}`;
    }
    if(body.name){
      url+=`&name=${body.name}`
    }
    if(body.merchantId){
      url+=`&merchantId=${body.merchantId}`
    }
    return this.regularGetRequest(url,headers);
}
  public getWithdrawalReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });

    let url = `api/get-withdrawl-report?&page=${body.page}&limit=50&isAll=${body.isAll}`;

    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.minAmount) {
      url += `&minAmount=${body.minAmount}`;
    }
    if (body.maxAmount) {
      url += `&maxAmount=${body.maxAmount}`;
    }
    if (body.withdrawalStatus) {
      url += `&withdrawalStatus=${body.withdrawalStatus}`;
    }
    if (body.channelType) {
      url += `&channelType=${body.channelType}`;
    }

    return this.regularGetRequest(url, headers);
  }

  public getBetListReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });

    let url = `api/gy-bet-list?page=${body.page}&limit=${body.limit}&isAll=${body.isAll}`;

    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.product) {
      url += `&product=${body.product}`;
    }

    return this.regularGetRequest(url, headers);
  }

  public reIssueTicket(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/reissue-ticket";
    return this.regularPostRequest(url, body, headers);
  }

  public getTransactions(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-transactions";
    return this.regularPostRequest(url, body, headers);
  }

  public getWalletTransactions(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/remittance-wallet-location-history?page=${page}&limit=20`;
    return this.regularPostRequest(url, body, headers);
  }

  public getRiaTransactions(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/transaction-history-remittance-wallet`;
    return this.regularPostRequest(url, body, headers);
  }

  public getCashier(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-cashier-by-location-id";
    return this.regularPostRequest(url, body, headers);
  }

  public getDepositUser(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/get-location-users?";
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public getlocationCashiers(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-location-cashiers";
    return this.regularPostRequest(url, body, headers);
  }
  public getWalletStatement(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/wallet-statement";
    return this.regularPostRequest(url, body, headers);
  }
  public getGamerLiability(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/gamer-liability-report?&page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getConsumerSummary(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/gamer-liability-report-bglc?&page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public getPosGamer(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/pos-gamer-report?&page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }
  public getDemographicsReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/demographics-report";
    return this.regularPostRequest(url, body, headers);
  }
  public getwinnerAwarenessReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/winner-awareness-report";
    return this.regularPostRequest(url, body, headers);
  }
  public getTerminalByLocation(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-terminal-by-location-id?locationId=${id}`;
    return this.regularGetRequest(url, headers);
  }

  public manageFundsVerification(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/manage-wallet-funds-verification";
    return this.regularPostRequest(url, body, headers);
  }

  public manageFunds(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/manage-wallet-funds";
    return this.regularPostRequest(url, body, headers);
  }

  public verifyCashIn(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/ria-funds-transfer-verification";
    return this.regularPostRequest(url, body, headers);
  }

  public riaCashIn(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/cashin-remittance-wallet`;
    return this.regularPostRequest(url, body, headers);
  }

  public riaAddFunds(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/add-ria-location-payment`;
    return this.regularPostRequest(url, body, headers);
  }

  public verifyCashOut(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/ria-funds-transfer-verification";
    return this.regularPostRequest(url, body, headers);
  }

  public riaCashOut(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/cashout-remittance-wallet`;
    return this.regularPostRequest(url, body, headers);
  }

  public getConfiguration(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-game-configuration";
    return this.regularGetRequest(url, headers);
  }

  public reprintTicketData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/reprint-ticket";
    return this.regularPostRequest(url, body, headers);
  }

  public cancelTicketData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = "api/cancel-ticket";
    return this.regularPostRequest(url, body, headers);
  }

  public reissueTicketData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = "api/cancel-with-reissue-ticket";
    return this.regularPostRequest(url, body, headers);
  }

  //ria reports

  public riaPaymentErrorHistory(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-payment-errors-history?page=${page}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public riaTransferSummaryReport(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-transfer-summary-report?page=${page}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public riaInflowsSummaryReport(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-inflows-summary-report?page=${page}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public riaInboundParishSummaryReport(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-inbound-parish-summary-report?page=${page}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public getPanelHistoryData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-panel-history`;

    return this.regularPostRequest(url, body, headers);
  }
  public getPanelData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-panels`;

    return this.regularPostRequest(url, body, headers);
  }

  public getMposPanelData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-panels-bglc`;

    return this.regularPostRequest(url, body, headers);
  }
  public getRevenueReportData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/revenue-report`;

    return this.regularPostRequest(url, body, headers);
  }

  public payTicket(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ticket-pay`;

    return this.regularPostRequest(url, body, headers);
  }

  public payTicketNew(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      deviceId: this.deviceId,
    });
    const url = `api/pay-igt-ticket`;

    return this.regularPostRequest(url, body, headers);
  }

  public getEodReport(param): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/end-of-the-day-report";

    return this.regularPostRequest(url, param, headers);
  }

  public getSupasellazEod(param): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/end-of-the-day-report-bglc";

    return this.regularPostRequest(url, param, headers);
  }

  public getAltenarToken(merchantType) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-altenar-token`;
    if (merchantType == 'GY') {
      url = `api/get-altenar-token-gy`;
    }
    return this.regularGetRequest(url, headers);
  }

  public altenarPrint(body, merchantType) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/altenar-print-data`;
    if (merchantType == 'GY') {
      url = `api/altenar-print-data-gy`
    }
    return this.regularPostRequest(url, body, headers);
  }

  public getNumberTerminalPrint(param): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/terminal-report";

    return this.regularPostRequest(url, param, headers);
  }
  public gettotalCash(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/cashflow-report`;

    return this.regularPostRequest(url, body, headers);
  }
  public getAccessRole(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-access-role`;

    return this.regularPostRequest(url, body, headers);
  }

  public getAccessToFintech(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-cashier-wallet?version=1.1`;

    return this.regularPostRequest(url, body, headers);
  }

  public cashinOut(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/consumer-wallet`;

    return this.regularPostRequest(url, body, headers);
  }

  public cashInCashOutGy(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/consumer-cashin-gy`;

    return this.regularPostRequest(url, body, headers);
  }

  //ticket-liability
  public ticketLiability(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/ticket-liability";
    return this.regularPostRequest(url, body, headers);
  }
  public getliabilityPercentageReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/liability-percentage-report";
    return this.regularPostRequest(url, body, headers);
  }
  public getliabilityReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/liability-report";
    return this.regularPostRequest(url, body, headers);
  }
  /* GLI REPORTS APIS */
  public gliLiabilityReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/new-liability-report?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public drawDetailsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-draw-information?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public gliGeneralizedReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-gli-reports?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public gameDetailsReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/game-wise-details`;
    return this.regularPostRequest(url, body, headers);
  }

  public userAccessReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/user-access-logging?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  public incentiveLoggingReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/incentive-report?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //gli apis end

  public getLocationGroupDataById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-location-group-by-id?locationGroupId=${id}`;

    return this.regularGetRequest(url, headers);
  }
  public getGroupById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-group?groupId=${id}`;

    return this.regularGetRequest(url, headers);
  }
  public getLookups(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/lookups`;
    if (body.merchantId) {
      url += `?merchantId=${body.merchantId}`;
    }

    return this.regularPostRequest(url, body, headers);
  }
  public getLocationsByScreenName(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/get-locations-by-screen-name?version=1.1";

    return this.regularPostRequest(url, body, headers);
  }
  public getDropdownValues(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/get-dropdowns?version=1.1";

    return this.regularPostRequest(url, body, headers);
  }
  public getLocationById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-location-by-id?locationId=${id}`;
    //  const url = `api/kiosk/get-location-data-by-id?locationId=${id}`

    return this.regularGetRequest(url, headers);
  }
  public getGroupByFilter(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-group-by-filter";

    return this.regularPostRequest(url, body, headers);
  }
  public getAllManagers(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-all-managers`;

    return this.regularGetRequest(url, headers);
  }
  public getNewUserDataById(userId): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-user?userId=${userId}`;

    return this.regularGetRequest(url, headers);
  }
  public getNotes(retailerId, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-retailer-visit-notes?retailerId=${retailerId}&page=${page}&limit=10`;

    return this.regularGetRequest(url, headers);
  }
  public addNewNote(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/add-retailer-notes`;

    return this.regularPostRequest(url, body, headers);
  }
  public editNewNote(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/update-retailer-notes`;

    return this.regularPostRequest(url, body, headers);
  }
  public deleteNote(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/delete-retailer-notes`;

    return this.regularPostRequest(url, body, headers);
  }
  public getMerchantList(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-all-merchants`;

    return this.regularGetRequest(url, headers);
  }
  public getRoleList(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-user-roles`;

    return this.regularGetRequest(url, headers);
  }
  public getUsers(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-user-search/v2`;

    return this.regularPostRequest(url, body, headers);
  }
  public getLocationCashier(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-location-manager-and-cashier`;

    return this.regularPostRequest(url, body, headers);
  }
  public addUsers(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/add-user?version=1.1";

    return this.regularPostRequest(url, body, headers);
  }
  public addNewLocationGroup(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/add-new-location-group";

    return this.regularPostRequest(url, body, headers);
  }
  public addNewGroup(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/add-new-group";

    return this.regularPostRequest(url, body, headers);
  }
  // public addNewLocation(body): Observable<any> {
  //   const headers: HttpHeaders = new HttpHeaders({
  //     Authorization: `Bearer ${this.accessToken}`,
  //     "Content-Type": "application/json",
  //   });
  //   const url = "api/add-new-location";

  //   return this.regularPostRequest(url, body, headers);
  // }
  public addNewLocation(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/kiosk/add-new-location?version=1.1";

    return this.regularPostRequest(url, body, headers);
  }
  public getGroups(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-group-by-filter`;

    return this.regularPostRequest(url, body, headers);
  }
  public getLocationList(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-location-list`;

    return this.regularPostRequest(url, body, headers);
  }
  public getLocationGroup(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-location-group`;
    return this.regularPostRequest(url, body, headers);
  }
  public getsellingPosReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/pos-and-gamer-details`;
    return this.regularPostRequest(url, body, headers);
  }
  public getTicketsReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/tickets-report`;
    return this.regularPostRequest(url, body, headers);
  }
  public getsalesReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/sales-report`;
    return this.regularPostRequest(url, body, headers);
  }
  public getLotteryGame(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-lottary-game?gameId=2`;

    return this.regularGetRequest(url, headers);
  }
  public getWinningNumbers(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-winning-numbers";

    return this.regularPostRequest(url, body, headers);
  }
  public getresults(from, to, gameId, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    var url = `api/get-winnings?gameId=${gameId}`;
    if (from) {
      url += `&from=${from}`;
    }
    if (to) {
      url += `&to=${to}`;
    }
    if (page) {
      url += `&page=${page}`;
    }
    return this.regularGetRequest(url, headers);
  }
  // public /api/get-orders?gameId=2&source=staff&date=12/12/
  public getOrders(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-orders`;
    return this.regularPostRequest(url, body, headers);
  }
  public savePostWinning(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/save-post-winning";

    return this.regularPostRequest(url, body, headers);
  }
  public changePassword(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/change-password";

    return this.regularPostRequest(url, body, headers);
  }
  public saveBetDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
      ClientType: this.clientType,
      deviceId: this.deviceId,
    });
    const url = "api/save-bet-details";

    return this.regularPostRequest(url, body, headers);
  }
  public voidTicket(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/void-tickets";

    return this.regularPostRequest(url, body, headers);
  }
  public getInvoiceData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/invoice-report";

    return this.regularPostRequest(url, body, headers);
  }

  public getInvoiceReportData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/retailer-invoice-v2";

    return this.regularPostRequest(url, body, headers);
  }

  public getSLPInvoiceReportData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/retailer-invoice-topup-ui";

    return this.regularPostRequest(url, body, headers);
  }

  public getBackofficeInvoiceReportData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-retailer-all-invoices";

    return this.regularPostRequest(url, body, headers);
  }

  public getNetSalesData(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/net-sales-report`;

    return this.regularPostRequest(url, body, headers);
  }

  //NWC/jps/digicel APIS

  public getaccountDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-bill-payment?billerType=${body.billerType}&accountId=${body.accountId ? body.accountId : ""}${body.billerType == "DIGICEL"
      ? body.mobile != ""
        ? "&mobile=" + body.mobile
        : ""
      : ""
      }&operator=${body.operator}&clientIp=${this.clientIp}&clientType=${body.clientType
      }&deviceId=${body.deviceId}&latitude=${body.latitude}&longitude=${body.longitude
      }&merchantType=JM&billerId=${body.billerId ? body.billerId : ""}`;
    if (body.version) {
      url += `&version=${body.version}`
    }

    return this.regularGetRequest(url, headers);
  }

  public getDigicelaccountDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });

    let url = `api/get-bill-payment?billerType=${body.billerType}`;

    body.mobile ? url += `&mobile=${body.mobile}` : url += `&mobile=${''}`;
    body.accountId ? url += `&accountId=${body.accountId}` : url += `&accountId=${''}`;
    url += `&operator=${body.operator}`;
    url += `&clientIp=${this.clientIp}`;
    url += `&clientType=${body.clientType}`;
    url += `&deviceId=${body.deviceId}`;
    url += `&latitude=${body.latitude}`;
    url += `&longitude=${body.longitude}`;
    url += `&merchantType=JM`;

    return this.regularGetRequest(url, headers);
  }

  public getVerestroAccountDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });

    let url = `api/get-verestro-user-data?`;

    url += `merchantId=${body.merchantType}`;
    url += `&phone=${body.phone}`;
    if (body.trn !== undefined) {
      url += `&trn=${body.trn}`;
    } else {
      url += `&email=${body.email}`;
    }
    url += `&clientType=${body.clientType}`;
    url += `&deviceId=${body.deviceId}`;
    url += `&latitude=${body.latitude}`;
    url += `&longitude=${body.longitude}`;
    url += `&clientIp=${body.clientIp}`;

    return this.regularGetRequest(url, headers);
  }

  public splitPayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/save-bill-payment-split";

    return this.regularPostRequest(url, body, headers);
  }
  public initiateVerestroTransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/initiate-verestro-transaction";

    return this.regularPostRequest(url, body, headers);
  }
  public confirmVerestroOtpTransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/confirm-verestro-transaction";

    return this.regularPostRequest(url, body, headers);
  }
  // --- Platform Configurations > Evo Cash ---------------------------------

  public getEvoCashCommission(): Observable<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${this.accessToken}`, 'Content-Type': 'application/json' });
    return this.regularGetRequest('api/get-evo-cash-commission', headers);
  }

  public saveEvoCashCommission(body): Observable<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${this.accessToken}`, 'Content-Type': 'application/json' });
    return this.regularPostRequest('api/save-evo-cash-commission', body, headers);
  }

  public getEvoCashServiceFee(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-evo-cash-service-fee";

    return this.regularGetRequest(url, headers);
  }

  public saveEvoCashServiceFee(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/save-evo-cash-service-fee";

    return this.regularPostRequest(url, body, headers);
  }

  public getEvoCashServiceFeeHistory(transactionType): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/get-evo-cash-service-fee-history?limit=50";
    if (transactionType) {
      url += `&transactionType=${transactionType}`;
    }

    return this.regularGetRequest(url, headers);
  }

  /**
   * Fee breakdown for an amount about to be transacted. The cashier screen uses
   * this so the total it shows is produced by the same code that will charge it.
   */
  public getEvoCashFeeQuote(transactionType, amount): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-evo-cash-fee-quote?transactionType=${transactionType}&amount=${amount}`;

    return this.regularGetRequest(url, headers);
  }

  public getPlatformConfigAccess(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-platform-config-access";

    return this.regularGetRequest(url, headers);
  }

  public verestroCashIn(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/cash-in-verestro";

    return this.regularPostRequest(url, body, headers);
  }

  public verestroCashOut(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/cash-out-verestro";

    return this.regularPostRequest(url, body, headers);
  }

  public payAmount(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = "api/pay-bill-payment";
    if(body.version){
        url += `?version=${body.version}`
      }
    return this.regularPostRequest(url, body, headers);
  }

  public getBillerConfig(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-biller-configurations?merchantType=JM`;
    if (body.version) {
      url += `&version=${body.version}`
    }
    if (body.billerName) {
      url += `&billerName=${body.billerName}`
    }
    if (body.limit) {
      url += `&limit=${body.limit}`
    }
    if (body.page) {
      url += `&page=${body.page}`
    }

    return this.regularGetRequest(url, headers);
  }

  public nwcEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-payments-history?&page=${page}&version=1.1`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }

    if (body.billerType) {
      url += `&billerType=${body.billerType}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.voidStatus) {
      url += `&voidStatus=${body.voidStatus}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    if (body.version) {
      url += `&version=${body.version}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public nwcAdjustment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/bill-payment-adjust-transaction`;

    return this.regularPostRequest(url, body, headers);
  }

  public voidJPSTransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/jps-void-transaction`;

    return this.regularPostRequest(url, body, headers);
  }
  public voidDigicelTransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/void-bp-transaction`;

    return this.regularPostRequest(url, body, headers);
  }
  public voidBillerTransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/void-transaction`;

    return this.regularPostRequest(url, body, headers);
  }

  public sendEmail(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/bill-payment-email";

    return this.regularPostRequest(url, body, headers);
  }
  public sendVerestroEmail(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/verestro-payment-email";

    return this.regularPostRequest(url, body, headers);
  }
  public getFundsDetailsLocation(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-remittance-balance-by-location-id`;

    return this.regularPostRequest(url, body, headers);
  }
  public getFundsDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-remittance-balance`;

    return this.regularPostRequest(url, body, headers);
  }

  //JPS TRANSACTION
  public jpsmethodOfPayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/save-jps-bill-payment-split";

    return this.regularPostRequest(url, body, headers);
  }
  //RIA Transaction Details

  public getRiatransaction(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-ria-transfer-details";

    return this.regularPostRequest(url, body, headers);
  }
  public confirmRiapayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/proceed-to-payment";

    return this.regularPostRequest(url, body, headers);
  }
  public CancelRiaPayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/cancel-ria-transaction";

    return this.regularPostRequest(url, body, headers);
  }

  public getRiaReports(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/ria-analytics-reports?&page=${page}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.reportType) {
      url += `&reportType=${body.reportType}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.limit) {
      url += `&limit=${body.limit}`
    }
    if (isAll) {
      url += `&isAll=${isAll}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getHighRiskCustomer(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/ria-high-risk-customer-reports?`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.reportType) {
      url += `&reportType=${body.reportType}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public riaRequireddata(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/ria-form-data";

    return this.regularPostRequest(url, body, headers);
  }

  public riaRequireddataLevel2(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/ria-second-level-data";

    return this.regularPostRequest(url, body, headers);
  }

  public riaSaveSignature(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = "api/ria-save-signature";

    return this.regularPostRequest(url, body, headers);
  }

  public getRiaOrderByIds(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = "api/get-ria-order-by-ids?";
    if (body.id) {
      url += `&id=${body.id}`;
    }
    if (body.type) {
      url += `&type=${body.type}`;
    }

    return this.regularGetRequest(url, headers);
  }

  public reupload(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/notify-reupload-document`;
    return this.regularPostRequest(url, body, headers);
  }

  public getAlessaStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-alessa-transaction-response?merchantType=JM`;
    return this.regularPostRequest(url, body, headers);
  }
  public eddFlagUpdate(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    })
    const url = `api/edd-flag-update`;
    return this.regularPostRequest(url, body, headers)
  }
  public riaEod(body, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-payment-history?&isAll=${isAll}`;

    return this.regularPostRequest(url, body, headers);
  }

  public riaEodV2(body, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/ria-payment-history-v2?&isAll=${isAll}`;

    return this.regularPostRequest(url, body, headers);
  }

  public digicelEod(body, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/digicel-payment-history?&isAll=${isAll}`;

    return this.regularPostRequest(url, body, headers);
  }

  public jpsEod(body, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/jps-payment-history?&isAll=${isAll}`;

    return this.regularPostRequest(url, body, headers);
  }

  public jpsBillPaymentEmail(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/jps-bill-payment-email";

    return this.regularPostRequest(url, body, headers);
  }
  //transactionSummaryReport
  public flowtransactionSummaryReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/flow-transaction-volume-summary?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //Monthly Agent Activity Report
  public monthlyAgentActivity(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/flow-monthly-agent-activity?page=${page}&limit=50&isAll=${isAll}&version=1.1`;
    return this.regularPostRequest(url, body, headers);
  }
  //Commission Summary Report
  public commissionSummaryReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/commission-summary-report?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //Bill Payment Boj Report
  public billPAymentBojReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/bill-payment-boj-file-data?page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.billerCategory) {
      url += `&billerCategory=${body.billerCategory}`;
    }

    return this.regularGetRequest(url, headers);
  }
  // unclaimed winnings report
  public unclaimedWinningsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/altenar-unclaimed-winnings?page=${page}&limit=50&isAll=${isAll}`;
    if (body.merchantCode) {
      url += `&merchantCode=${body.merchantCode}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.betReferenceNum) {
      url += `&betReferenceNum=${body.betReferenceNum}`;
    }

    return this.regularGetRequest(url, headers);
  }
  //altenar-unclaimed-winning-report
  public altenarUnclaimedWinningsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/altenar-unclaimed-winning-report?page=${page}&limit=50&isAll=${isAll}`;
    if (body.merchantCode) {
      url += `&merchantCode=${body.merchantCode}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.betReferenceNum) {
      url += `&betReferenceNum=${body.betReferenceNum}`;
    }

    return this.regularGetRequest(url, headers);
  }

  //Monthly Adjustment Report
  public monthlyAdjustmentReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/flow-monthly-adjustment?page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //daily net profit sales report
  public dailyNetProfitSalesReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/get-daily-sales-details`;
    return this.regularPostRequest(url, body, headers);
  }

  //Platform Reports
  public createPlatformReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = `api/create-report-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public getAltenarReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/altenar-bet-history-report`;
    return this.regularPostRequest(url, body, headers);
  }

  public getRetailerAltenarReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/altenar-bet-history`;
    return this.regularPostRequest(url, body, headers);
  }

  public getadminRetailerAltenarReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/altenar-retailer-bet-history-report`;
    return this.regularPostRequest(url, body, headers);
  }

  public getconsumerAmtoteReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/horse-racing/consumer-bet-history-report`;
    return this.regularPostRequest(url, body, headers);
  }

  //cash-flow-report
  public getAltenarCashFlowReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/altenar-cash-flow-report?&page=${page}&limit=50&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //cash-flow-report
  public getAltenarWeeklyReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/altenar-week-ending-report?&page=${page}&limit=50&isAll=${isAll}`;
    if (body.merchantCode) {
      url += `&merchantCode=${body.merchantCode}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.regularGetRequest(url, headers);
  }

  //STR APIs
  public getRiaStrRequest(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/ria-str-request`;
    return this.regularPostRequest(url, body, headers);
  }

  public updateRiaStrRequest(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/ria-str-request-update`;
    return this.regularPostRequest(url, body, headers);
  }

  public getRiaStrById(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-ria-str-history-by-id`;
    return this.regularPostRequest(url, body, headers);
  }

  public getRiaStrHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-ria-str-history?&page=${page}&isAll=${isAll}`;
    return this.regularPostRequest(url, body, headers);
  }

  //end of str apis

  public getMbetPayoutHistoryReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/horse-racing/bet-history`;
    return this.regularPostRequest(url, body, headers);
  }

  public getAdminHistoryReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/horse-racing/bet-history-report`;
    return this.regularPostRequest(url, body, headers);
  }

  public getPlatformReports(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-report-request?page=${page}&count=10`;
    if (body.from_date) {
      url += `&from_date=${body.from_date}`;
    }
    if (body.to_date) {
      url += `&to_date=${body.to_date}`;
    }
    if (body.merchant_id) {
      url += `&merchant_id=${body.merchant_id}`;
    }
    if (body.report_name) {
      url += `&report_name=${body.report_name}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getPendingAccountsReport(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/pending-accounts-report?page=${page}&limit=50&isAll=${isAll}`
    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    return this.regularGetRequest(url, headers);
  }
  public getCardSummaryReport(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-blocked-card-data?&page=${page}&limit=50&isAll=${isAll}`
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.name) {
      url += `&name=${body.name}`;
    }
    if (body.email) {
      url += `&email=${body.email}`;
    }
    if (body.eventType) {
      url += `&eventType=${body.eventType}`;
    }
    if (body.cardNumber) {
      url += `&cardNumber=${body.cardNumber}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getRolesPlatformReports(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-report-role-base`;
    return this.regularGetRequest(url, headers);
  }

  public guyanaNumberSalesReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/guyana-number-sales?`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public billPaymentsEod(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/flow-eod-summary?page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.billerName) {
      url += `&billerName=${body.billerName}`;
    }
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public verestroEodReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/verestro-eod-summary?page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.transactionType) {
      url += `&transactionType=${body.transactionType}`;
    }
    if (body.locationId) {
      url += `&locationId=${body.locationId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public billPaymentsErrorLog(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/flow-bill-error-log-report?`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.billerName) {
      url += `&billerName=${body.billerName}`;
    }
    return this.regularGetRequest(url, headers);
  }

  // Kiosk get apis

  public getKioskTerminals(body, isAll, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/kiosk/get-kiosk-terminal`;
    return this.regularPostRequest(url, body, headers);
  }
  // Terminal By Id 
  public getKioskTerminalById(terminalId) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/kiosk/get-kiosk-terminal?terminalId=${terminalId}`;
    return this.regularGetRequest(url, headers,);
  }

  //terminal unbind
  public unBindKioskTerminal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    const url = `api/kiosk/unbind-kiosk-terminal`
    return this.regularPostRequest(url, body, headers)
  }
  //terminal bind
  public bindKioskTerminal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    const url = `api/kiosk/bind-kiosk-terminal`
    return this.regularPostRequest(url, body, headers)
  }


  //add terminal

  public addTerminal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    const url = `api/kiosk/add-kiosk-terminal`
    return this.regularPostRequest(url, body, headers)
  }

  // Update Terminal 
  public updateTerminal(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/kiosk/edit-kiosk-terminal";
    return this.regularPutRequest(url, body, headers);
  }

  // delete terminal
  public deleteKioskTerminal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    const url = `api/kiosk/remove-kiosk-terminal`
    return this.regularPostRequest(url, body, headers)
  }
  // update terminal status
  public changeTerminalStatus(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    const url = `api/kiosk/update-kiosk-terminal-status`
    return this.regularPostRequest(url, body, headers)
  }

  //kiosk games draw details
  public getKioskAvailableDraw(gameId) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      // Authorization: `Bearer ${this.accessToken}`,
    });
    const url = `api/kiosk/jm-available-draws?gameId=${gameId}`;
    return this.regularGetRequest(url, headers);
  }
  public getkioskTerminalStatus(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-terminal-stats?&terminalId=${body.terminalId}&limit=10&page=${page}&isAll=${isAll}`
    return this.regularGetRequest(url, headers);
  }

  public getkioskTerminalStatusDetail(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-terminal-stats-by-id?&terminalId=${body.terminalId}&limit=10&page=${page}&isAll=${isAll}`
    return this.regularGetRequest(url, headers);
  }

  //kiosk cashpot draw details
  public getCashpotAvailableDraw() {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const url = `api/kiosk/game-draws?Merchant-Type=JM&Channel-Type=KIOSK`;
    return this.regularGetRequest(url, headers);
  }

  public getKioskConfiguration(): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const url = "api/kiosk/get-game-configuration?Merchant-Type=JM";
    return this.regularGetRequest(url, headers);
  }
  //get terminal activity log
  public getKioskTerminalActivityLog(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-kiosk-terminal-activity-report?page=${page}&isAll=${isAll}&limit=10`;
    if (body.terminalId) {
      url += `&terminalId=${body.terminalId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getKioskReports(body, isAll, page) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-kiosk-orders?page=${page}&isAll=${isAll}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public getKioskTransactionEodReport(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-kiosk-eod-transaction-report?page=${page}&isAll=${isAll}&limit=20`;
    return this.regularPostRequest(url, body, headers);
  }

  public getVoucherTransactionHistory(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-kiosk-voucher-transaction-report?page=${page}&isAll=${isAll}&limit=50`;
    return this.regularPostRequest(url, body, headers);
  }

  public kioskRetailerInvoiceReport(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/report`
    return this.regularPostRequest(url, body, headers);
  }

  public kioskVoucherRedemption(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/redeem-kiosk-voucher`
    return this.regularPostRequest(url, body, headers);
  }

  public getkioskVoucher(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/get-kiosk-voucher?&voucherNumber=${body.voucherNumber}`
    return this.regularGetRequest(url, headers);
  }

  //kiosk Anaylitics report
  public kioskAnalyticsReport(body) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    })
    let url = `api/kiosk/report`
    return this.regularPostRequest(url, body, headers);
  }
  /* Generic HTTP requests */

  // Get Game ID
  gameId(): Observable<any> {
    const url = "api/get-game-list";
    const headers: HttpHeaders = new HttpHeaders({
      // Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    return this.regularGetRequest(url, headers);
  }

  getWithdrawMmg(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-transaction-history-gy?&page=${page}&limit=50`;
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.fromDate) {
      url += `&fromDate=${body.fromDate}`;
    }
    if (body.toDate) {
      url += `&toDate=${body.toDate}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    return this.regularGetRequest(url, headers);
  }

  markTransactionStatus(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/update-transaction-status-gy";
    return this.regularPostRequest(url, body, headers);
  }

  //lat and lng

  getLocationsService(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((resp) => {
        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      });
    });
  }

  // Purchase Bet
  purchaseBet(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/save-purchase";
    return this.regularPostRequest(url, body, headers);
  }

  //Ticket-Payout Data
  ticketPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'ClientType': this.clientType,
      // 'deviceId': this.deviceId
    });
    const url = "api/ticket-payout";
    return this.regularPostRequest(url, body, headers);
  }

  getaltenarTicketPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'ClientType': this.clientType,
      // 'deviceId': this.deviceId
    });
    const url = "api/altenar-payout-data";
    return this.regularPostRequest(url, body, headers);
  }

  altenarTicketPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'ClientType': this.clientType,
      // 'deviceId': this.deviceId
    });
    const url = "api/altenar-payout";
    return this.regularPostRequest(url, body, headers);
  }

  newticketPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'ClientType': this.clientType,
      // 'deviceId': this.deviceId
    });
    const url = "api/ticket-info";
    return this.regularPostRequest(url, body, headers);
  }

  //horse-racing APIS

  public getMyWagers(body, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/horse-racing/bet-history?&page=${page}&limit=50`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    if (body.betType) {
      url += `&betType=${body.betType}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public cancelBet(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = `api/horse-racing/cancel-bet`;
    return this.regularPostRequest(url, body, headers);
  }

  public placeBet(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = `api/horse-racing/place-bet`;
    return this.regularPostRequest(url, body, headers);
  }
  public getTracksList(isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = `api/horse-racing/get-tracks?&isAll=${isAll}`;
    return this.regularGetRequest(url, headers);
  }

  public getTrackDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = `api/horse-racing/get-race-details`;
    return this.regularPostRequest(url, body, headers);
  }

  public getMbetPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/horse-racing/get-payout-details?`;
    if (body.serialNumber) {
      url += `&serialNumber=${body.serialNumber}`;
    }
    return this.regularGetRequest(url, headers);
  }

  mbetTicketPayout(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
      // 'ClientType': this.clientType,
      // 'deviceId': this.deviceId
    });
    const url = "api/horse-racing/payout";
    return this.regularPostRequest(url, body, headers);
  }
  public switchedCashDigitalReport(body, isAll, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/switched-from-cash-to-digital-report?page=${page}&isAll=${isAll}&merchantId=JM`;
    if (body.dateFrom) {
      url += `&startDate=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&endDate=${body.dateTo}`;
    }
    if (body.limit) {
      url += `&limit=${body.limit}`
    }
    return this.regularGetRequest(url, headers);
  }

   public getCustomerDataReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/customer-data-report?page=${page}&isAll=${isAll}`;
    
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.userId) {
      url += `&userId=${body.userId}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.externalId) {
      url += `&externalId=${body.externalId}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }

    return this.regularGetRequest(url, headers);
  }

  public getConsumerWalletBalanceReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-consumer-wallet-balance-report?page=${page}&isAll=${isAll}`;

    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.userId) {
      url += `&userId=${body.userId}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }

    return this.regularGetRequest(url, headers);
  }


  public getCustomerListingReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-customer-listing-report?page=${page}&limit=${body.limit}&isAll=${isAll}`;

    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }

    return this.regularGetRequest(url, headers);
  }

    public getCurrencyTransactionReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-currency-transaction-report?page=${page}&limit=50&isAll=${isAll}`;
    if (body.startDate){
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate){
      url += `&endDate=${body.endDate}`;
    }
    if (body.merchantId){
      url += `&merchantId=${body.merchantId}`;
    } 
    if (body.startAmount){
      url += `&startAmount=${body.startAmount}`;
    }
    if (body.endAmount){
      url += `&endAmount=${body.endAmount}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getCustomerDepositTransactionsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-customer-deposit-transactions?page=${page}&limit=${body.limit}&isAll=${isAll}`;
    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getCustomerGamingTransactionsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-customer-gaming-transaction-report?page=${page}&limit=${body.limit}&isAll=${isAll}`;
    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getCashFlowReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-cash-flow-report?page=${page}&limit=${body.limit}&isAll=${isAll}`;
    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getCustomerWithdrawalTransactionsReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-customer-withdrawal-transactions?page=${page}&limit=${body.limit}&isAll=${isAll}`;
    if (body.merchantId) {
      url += `&merchantId=${body.merchantId}`;
    }
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.mobile) {
      url += `&mobile=${body.mobile}`;
    }
    return this.regularGetRequest(url, headers);
  }

  public getSuspiciousWalletReport(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/get-Suspicious-Wallet-Report?page=${page}&isAll=${isAll}`;
    if (body.merchantType) {
      url += `&merchantType=${body.merchantType}`;
    }
    if (body.startDate) {
      url += `&startDate=${body.startDate}`;
    }
    if (body.endDate) {
      url += `&endDate=${body.endDate}`;
    }
    if (body.startAmount) {
      url += `&startAmount=${body.startAmount}`;
    }
    if (body.endAmount) {
      url += `&endAmount=${body.endAmount}`;
    }
    return this.regularGetRequest(url, headers);
  }

  // END
  regularPostRequest(url, formData, headers) {
    return super.makePostRequest(url, formData, headers).pipe(
      map(super.extractData),
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e.status == 401 || e.status == 403) {
          CommonService.apiErrorStatus = true;
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }
  // regularKioskPostRequest(url, formData, headers) {
  //   return super.makeKioskPostRequest(url, formData, headers).pipe(
  //     map(super.extractData),
  //     catchError((e) => {
  //       if (document.getElementById("loader")) {
  //         document.getElementById("loader").style.display = "none";
  //       }
  //       if (e.status == 401 || e.status == 403) {
  //         CommonService.apiErrorStatus = true;
  //       }
  //       if (e instanceof Response && window.location.hostname !== "localhost") {
  //         window.location.reload();
  //       } else {
  //         return throwError(new Error(`${e.status} ${e.statusText}`));
  //       }
  //     })
  //   );
  // }

  regularPutRequest(url, body, headers) {
    return super.makePutRequest(url, body, headers).pipe(
      map(super.extractData),
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }

  regularGetRequest(url, headers) {
    return super.makeGetRequest(url, headers).pipe(
      map(super.extractData),
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e.status == 401 || e.status == 403) {
          CommonService.apiErrorStatus = true;
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }
  // regularKioskGetRequest(url, headers,isKiosk: boolean = false) {
  //   return super.makeKioskGetRequest(url, headers,isKiosk).pipe(
  //     map(super.extractData),
  //     catchError((e) => {
  //       if (document.getElementById("loader")) {
  //         document.getElementById("loader").style.display = "none";
  //       }
  //       if (e.status == 401 || e.status == 403) {
  //         CommonService.apiErrorStatus = true;
  //       }
  //       if (e instanceof Response && window.location.hostname !== "localhost") {
  //         window.location.reload();
  //       } else {
  //         return throwError(new Error(`${e.status} ${e.statusText}`));
  //       }
  //     })
  //   );
  // }

  public getUnidentifiedwithdrawal(batchId, transactionType, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/get-all-mass-payment-by-batchId?&batchId=${batchId}&transactionType=${transactionType}&page=${page}&limit=100&isAll=${isAll}`;
    return this.regularGetRequest(url, headers);
  }

  regularDeleteRequest(url, body, headers) {
    return super.makeDeleteRequest(url, body, headers).pipe(
      catchError((e) => {
        if (document.getElementById("loader")) {
          document.getElementById("loader").style.display = "none";
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }


  public updateGameCart(newGameDataObject: any): void {
    const gameIdToUpdate = newGameDataObject.gameId;
    const drawCountToUpdate = newGameDataObject.drawCount;
    const existingIndex = this.globalCartData.bettingDetails.findIndex(
      (game: any) =>
        game.gameId === gameIdToUpdate
    );

    if (newGameDataObject.bets.length === 0) {
      if (existingIndex !== -1) {
        this.globalCartData.bettingDetails.splice(existingIndex, 1);
      }
    } else if (existingIndex !== -1) {
      this.globalCartData.bettingDetails[existingIndex] = newGameDataObject;
    } else {
      this.globalCartData.bettingDetails.push(newGameDataObject);
    }
    // console.log("Global Cart ", this.globalCartData); 
  }

  public getGameCarts(gameId: number): any[] {
    return this.globalCartData.bettingDetails.filter(
      (game: any) => game.gameId === gameId
    );
  }

  public calculateTotalItems(): number {
    let totalCount = 0;
    if (this.globalCartData.bettingDetails && this.globalCartData.bettingDetails.length > 0) {
      this.globalCartData.bettingDetails.forEach((game: any) => {
        if (game.bets && game.bets.length > 0) {
          totalCount += game.bets.length;
        }
      });
    }
    return totalCount;
  }
 public getThresholdReport(body, isAll): Observable<any> {
  const headers: HttpHeaders = new HttpHeaders({
    Authorization: `Bearer ${this.accessToken}`,
    "Content-Type": "application/json",
  });

  const url = `api/compliance-threshold-report`;
  body.isAll = isAll?"true": "false";

  return this.regularPostRequest(url,body, headers);
}
// KIOSK TRANSACTION REPORT 
  public getKioskTransactionReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });

    let url = `api/kiosk/get-kiosk-transaction-report`;    
   return this.regularPostRequest(url, body, headers);
  }
   //chatbot history api
  public getChatbotHistory(page: number, size: number): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    let url = `api/svl-chatbot-history?userToken=${this.accessToken}&page=${page}&size=${size}`;
    return this.regularPostRequest(url, '', headers);
  }

      public getLmTrasactionHistoryReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    const url = "api/get-transactions-history";
    return this.regularPostRequest(url, body, headers);
  }

    public getChargeUpStatementReport(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/charge-Up-Commission-Statement-Report?page=${body.page}&limit=${body.limit}&isAll=${body.isAll}`;
    return this.regularPostRequest(url, body, headers);
  }
  public reverseFunds(body):Observable<any>{
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      "Content-Type": "application/json",
    });
    let url = `api/reverse-transaction`;
    return this.regularPostRequest(url,body,headers);
  }

  public viewKioskSerialNumber(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.accessToken}`,
    });
    const url = 'api/kiosk/view-kiosk-serial-number';
    return this.makePostRequest(url, body, headers);
  }
}
